import X from "lodash/isFunction";
import { PendoTooltip as C } from "../../directives/tooltip/pendo-tooltip.js";
import b from "../../directives/loading/components/skeleton.vue.js";
import g from "./cell-types/pendo-checkbox-cell.vue.js";
import x from "./cell-types/tree.vue.js";
import D from "./cell-types/link.vue.js";
import { getProp as E } from "./utils/utils.js";
import { capitalize as M } from "../../utils/utils.js";
import { findNodeByContent as W, elementHasOverflow as V } from "../../utils/dom.js";
C.options.disposeTimeout = 0;
const Y = {
  name: "TableCell",
  inject: ["$table"],
  components: {
    Checkbox: g,
    Link: D,
    SkeletonLoader: b,
    Tree: x
  },
  directives: {
    PendoTooltip: C
  },
  props: {
    column: {
      type: Object
    },
    columnIndex: {
      type: Number
    },
    naturalIndex: {
      type: Number
    },
    row: {
      type: Object
    },
    rowIndex: {
      type: Number
    },
    rowLevel: {
      type: Number
    }
  },
  data() {
    return {
      tooltipContent: null
    };
  },
  computed: {
    hasDynamicNonVirtualRowHeight() {
      return this.row.height && !this.$table.scrollStore.dynamicRowHeight;
    },
    fixedColumnStyle() {
      const e = {};
      return this.$table.overflowX && (this.column.fixed === "left" && (e.left = `${this.column.fixedPos}px`), this.column.fixed === "right" && (e.right = `${this.column.fixedPos}px`)), this.hasDynamicNonVirtualRowHeight && (e.height = `${this.row.height}px`), e;
    },
    cellClassName() {
      return this.$table.cellClassName ? X(this.$table.cellClassName) ? this.$table.cellClassName({
        row: this.row,
        rowIndex: this.rowIndex,
        column: this.column,
        columnIndex: this.columnIndex
      }) : this.$table.cellClassName : "";
    },
    cellContentStyle() {
      const e = {};
      return !this.$table.scrollStore.rowHeight && this.hasDynamicNonVirtualRowHeight && (e.maxHeight = `${this.row.height}px`), this.$table.border ? (e.width = `${this.column.renderWidth - 1}px`, e) : (e.width = `${this.column.renderWidth}px`, e);
    },
    cellContent() {
      if (this.column.formatter)
        return this.column.formatter(this.row, this.column);
      const e = E(this.row, this.column.property);
      return e === 0 ? e : typeof e == "boolean" ? String(e) : e || "";
    },
    listenForClickEvents() {
      return ["index", "checkbox", "tree"].includes(this.column.type) ? !1 : this.$table.highlightCurrentRow || !!this.$table.$listeners["cell-click"];
    },
    listenForHoverEvents() {
      return this.$table.scrollStore.scrollActive ? !1 : this.showTooltip;
    },
    showClamp() {
      return this.column.showOverflow === "clamp";
    },
    showEllipsis() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === "ellipsis";
    },
    showTitle() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === "title";
    },
    showTooltip() {
      return ["actions", "index", "tree"].includes(this.column.type) ? !1 : this.column.showOverflow === !0 || this.column.showOverflow === "clamp" || this.column.showOverflow === "tooltip" || this.$table.showAllOverflow === !0 || this.$table.showAllOverflow === "clamp" || this.$table.showAllOverflow === "tooltip";
    },
    scrollActive() {
      return this.$table.scrollStore.scrollActive;
    },
    showLoading() {
      return !this.column.async || this.cellContent === 0 ? !1 : !this.cellContent;
    },
    showTreeExpand() {
      return this.$table.treeConfig && this.row[this.$table.treeConfig.children];
    }
  },
  watch: {
    scrollActive(e) {
      e && (this.tooltipContent = null);
    }
  },
  methods: {
    onCellClick(e) {
      this.$table.handleCellClick(e, {
        row: this.row,
        column: this.column,
        cell: e.currentTarget
      });
    },
    onCellHover({ currentTarget: e }) {
      if (this.tooltipContent = null, this.column.tooltipFormatter) {
        const r = this.column.tooltipFormatter(this.row, this.column);
        r && (this.tooltipContent = r);
        return;
      }
      const l = W(this.cellContent, e);
      l.length && V(l[0]) && requestAnimationFrame(() => {
        this.tooltipContent = this.cellContent;
      });
    },
    onCheckboxChange() {
      this.$table.toggleRowSelect({ row: this.row });
    }
  },
  render(e) {
    const {
      row: l,
      rowIndex: r,
      rowLevel: n,
      column: t,
      columnIndex: a,
      cellContent: v,
      naturalIndex: h,
      cellClassName: y,
      cellContentStyle: k,
      fixedColumnStyle: _,
      showTooltip: d,
      showClamp: $,
      showEllipsis: R,
      listenForClickEvents: N,
      listenForHoverEvents: T,
      onCellClick: A,
      onCellHover: H,
      onCheckboxChange: O,
      tooltipContent: S,
      $table: o,
      showLoading: p,
      showTreeExpand: u
    } = this;
    let i = v, s = !0;
    const f = {
      name: "pendo-tooltip",
      value: {
        content: S,
        delay: { show: 300, hide: 0 },
        arrow: !0,
        multiline: !0,
        html: !1,
        boundariesElement: "body"
      }
    }, m = t.slot || t.type || t.property;
    if (o.$slots[m] && !p && (s = !1, i = o.$slots[m]({
      row: l,
      rowIndex: r,
      column: t,
      columnIndex: a,
      toggleRowActive: o.toggleRowActive
    })), t && t.type)
      switch (s = !1, t.type) {
        case "checkbox": {
          i = e(g, {
            props: {
              checked: !!o.selectedMap[l[o.rowKey]],
              disabled: o.checkboxConfig.checkMethod && !o.checkboxConfig.checkMethod(l)
            },
            on: {
              change: O
            },
            directives: [f]
          });
          break;
        }
        case "link":
          i = e(M(t.type), {
            props: {
              row: l,
              rowLevel: n,
              column: t,
              content: i
            }
          });
          break;
        case "tree":
          u && (i = e(x, {
            props: {
              row: l,
              rowLevel: n
            }
          }));
          break;
        case "index":
          i = h;
          break;
        case "actions": {
          const { scrollActive: I } = o.scrollStore, L = n > 0;
          if (I || L) {
            i = [];
            break;
          }
          const F = l[o.rowKey] === o.hoverRow, P = l[o.rowKey] === o.activeRow;
          if (!F && !P) {
            i = [];
            break;
          }
        }
      }
    const c = {};
    N && (c.click = A), T && (c.mouseenter = H);
    const w = [];
    return d && t.type !== "checkbox" && w.push(f), e(
      "td",
      {
        class: [
          "pendo-table__column",
          y,
          {
            "pendo-table__column--actions": t.type === "actions",
            "pendo-table__column--center": t.align === "center",
            "pendo-table__column--right": t.align === "right",
            "pendo-table__column--fixed-left": o.overflowX && t.fixed === "left",
            "pendo-table__column--fixed-right": o.overflowX && t.fixed === "right",
            "pendo-table__column--fixed-shadow": t.fixedShadow,
            "is-fixed-actions": !o.scrollStore.scrollActive && o.overflowX && t.type === "actions",
            "is-fixed-left": o.overflowX && o.scrollLeftToRight && t.fixed === "left",
            "is-fixed-right": o.overflowX && o.scrollRightToLeft && t.fixed === "right"
          }
        ],
        style: _,
        attrs: {
          "pendo-draggable-handle": o.draggable,
          role: "gridcell",
          "aria-rowindex": h + 1,
          // must account for header row
          "aria-colindex": a + 1
        },
        on: c
      },
      [
        e(
          "div",
          {
            class: [
              "pendo-table__cell",
              {
                "pendo-table__cell--index": t.type === "index",
                "pendo-table__cell--text": s,
                "pendo-table__cell--tooltip": d,
                "pendo-table__cell--checkbox": t.type === "checkbox",
                "pendo-table__cell--tree": t.type === "tree" && u,
                "pendo-table__cell--ellipsis": R,
                "pendo-table__cell--clamp": $
              }
            ],
            style: k,
            attrs: {
              "pendo-draggable-handle": o.draggable && t.type !== "link",
              "pendo-draggable-ignore": o.draggable && t.type === "link"
            },
            directives: w
          },
          [
            p ? e(b, {
              props: {
                containerWidth: Math.max(0, parseInt(t.renderWidth - 32)),
                containerHeight: 8,
                skeletonProps: {
                  animate: !0,
                  borderRadius: 2,
                  height: 8,
                  primaryColor: "#eaecf1",
                  secondaryColor: "#f8f8f9",
                  speed: 2,
                  width: Math.max(0, parseInt(t.renderWidth - 32))
                }
              }
            }) : i
          ]
        )
      ]
    );
  }
};
export {
  Y as default
};
//# sourceMappingURL=table-cell.js.map
